import { render, staticRenderFns } from "./FlotasCompartidas.vue?vue&type=template&id=11703410&"
import script from "./FlotasCompartidas.vue?vue&type=script&lang=ts&"
export * from "./FlotasCompartidas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports